import { render, staticRenderFns } from "./AkvelonButton.vue?vue&type=template&id=4ca967dc&"
import script from "./AkvelonButton.vue?vue&type=script&lang=js&"
export * from "./AkvelonButton.vue?vue&type=script&lang=js&"
import style0 from "./AkvelonButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports